<template>
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 495.66 217.61"
    :width="props.width"
    :height="props.height"
    :fill="props.fill"
  >
    <defs>
      <clipPath id="clippath">
        <rect :class="{ st2: !props.fill }" x="5" y="5.19" width="485.66" height="207.24" />
      </clipPath>
      <clipPath id="clippath-1">
        <rect :class="{ st2: !props.fill }" x="5" y="5.19" width="485.66" height="207.24" />
      </clipPath>
      <clipPath id="clippath-2">
        <rect :class="{ st2: !props.fill }" x="5" y="5.19" width="485.66" height="207.24" />
      </clipPath>
      <clipPath id="clippath-3">
        <rect :class="{ st2: !props.fill }" x="5" y="5.19" width="485.66" height="207.24" />
      </clipPath>
      <clipPath id="clippath-4">
        <rect :class="{ st2: !props.fill }" x="5" y="5.19" width="485.66" height="207.24" />
      </clipPath>
      <clipPath id="clippath-5">
        <rect :class="{ st2: !props.fill }" x="5" y="5.19" width="485.66" height="207.24" />
      </clipPath>
      <clipPath id="clippath-6">
        <rect :class="{ st2: !props.fill }" x="5" y="5.19" width="485.66" height="207.24" />
      </clipPath>
    </defs>
    <polygon
      :class="{ st8: !props.fill }"
      points="115.73 78.42 115.73 137.8 105.55 137.8 105.55 92.24 77.3 126.51 76.71 126.51 48.46 92.24 48.46 137.8 38.62 137.8 38.62 78.42 49.64 78.42 77.22 112.43 104.78 78.42 115.73 78.42"
    />
    <polygon
      :class="{ st8: !props.fill }"
      points="187.42 91.31 152.3 154.77 141.95 154.77 153.57 134.74 129.31 91.31 140 91.31 158.66 125.24 176.98 91.31 187.42 91.31"
    />
    <g :class="{ st7: !props.fill }">
      <path
        :class="{ st8: !props.fill }"
        d="M262.96,136.67c-3.82,2.54-8.99,4.32-14.34,4.32-9.08,0-16.29-4.83-16.29-14.5v-25.79h-8.99v-7.89h8.99v-10.77h9.92v10.77h20.28v7.89h-20.28v24.18c0,5.17,3.99,7.72,8.82,7.72,3.48,0,6.45-1.27,9.25-2.8l2.63,6.87Z"
      />
      <path
        :class="{ st8: !props.fill }"
        d="M268.13,116.14c0-15.44,10.94-25.11,28.93-25.11s28.93,9.67,28.93,25.11-10.86,24.94-28.93,24.94-28.93-9.59-28.93-24.94M316.32,116.14c0-11.28-8.23-16.8-19.26-16.8s-19.17,5.51-19.17,16.8,8.23,16.63,19.17,16.63,19.26-5.51,19.26-16.63"
      />
    </g>
    <rect :class="{ st8: !props.fill }" x="336.6" y="76.53" width="9.84" height="62.77" />
    <g :class="{ st3: !props.fill }">
      <path
        :class="{ st8: !props.fill }"
        d="M411.08,113.43v16.88c0,3.48.59,6.28,2.12,8.99h-10.26c-1.19-2.04-1.78-4.32-1.78-6.53v-.09c-3.65,4.5-10.78,8.31-20.28,8.31-10.01,0-23.33-4.07-23.33-16.29s13.32-16.2,23.33-16.2,16.63,3.82,20.28,8.31v-3.39c0-10.01-6.11-14.51-18.07-14.51-6.87,0-12.3,1.53-17.65,4.67l-3.56-6.7c5.77-3.48,14.68-5.77,23.08-5.77,16.21,0,26.13,7.72,26.13,22.31M401.32,124.03c-3.73-6.45-11.62-8.4-18.58-8.4-6.19,0-15.44,1.61-15.44,9.08s9.25,9.16,15.44,9.16c6.96,0,14.84-2.04,18.58-8.4v-1.44Z"
      />
      <path
        :class="{ st8: !props.fill }"
        d="M449.6,141.08c-17.9,0-28.76-9.76-28.76-24.94s10.86-25.11,28.76-25.11c12.98,0,20.95,5.26,25.03,11.96l-9.33,3.99c-3.05-5.6-9.25-7.72-15.61-7.72-11.03,0-19.09,5.6-19.09,16.88s8.06,16.71,19.09,16.71c6.36,0,12.81-2.21,15.87-7.97l9.33,3.9c-4.07,7.04-12.05,12.3-25.28,12.3"
      />
    </g>
    <path :class="{ st8: !props.fill }" d="M12.76,12.95h191.72v191.72H12.76V12.95ZM5,212.43h207.24V5.19H5v207.24Z" />
    <g :class="{ st6: !props.fill }">
      <path
        :class="{ st8: !props.fill }"
        d="M490.65,134.84c0,3.4-2.76,6.16-6.16,6.16s-6.16-2.76-6.16-6.16,2.76-6.16,6.16-6.16,6.16,2.76,6.16,6.16M489.62,134.84c0-2.86-2.31-5.17-5.13-5.17s-5.14,2.3-5.14,5.17,2.3,5.17,5.14,5.17,5.13-2.3,5.13-5.17M485.92,135.59l1.31,2.4h-1.43l-1.1-2.13h-.92v2.13h-1.31v-6.3h2.13c1.52,0,2.4.92,2.4,2.04,0,.87-.37,1.52-1.07,1.86M483.78,134.67h.81c.7,0,1.09-.36,1.09-.87,0-.56-.39-.89-1.09-.89h-.81v1.75Z"
      />
    </g>
    <polygon
      :class="{ st8: !props.fill }"
      points="244.69 174.71 244.69 179.35 232.33 179.35 232.33 158.26 237.15 158.26 237.15 174.71 244.69 174.71"
    />
    <path
      :class="{ st8: !props.fill }"
      d="M267.59,176.04h-7.83l-1.06,3.31h-5.27l7.17-21.09h6.15l7.17,21.09h-5.27l-1.05-3.31ZM266.14,171.52l-2.47-7.75-2.47,7.75h4.94Z"
    />
    <polygon
      :class="{ st8: !props.fill }"
      points="300.14 158.26 300.14 179.35 296.52 179.35 288.38 167.9 288.38 179.35 283.56 179.35 283.56 158.26 287.18 158.26 295.32 169.71 295.32 158.26 300.14 158.26"
    />
    <g :class="{ st5: !props.fill }">
      <path
        :class="{ st8: !props.fill }"
        d="M318.71,172.42h-2.29v6.93h-4.82v-21.09h8.44c2.01,0,3.72.7,5.12,2.11,1.41,1.41,2.11,3.11,2.11,5.12,0,1.29-.36,2.48-1.07,3.57-.71,1.1-1.65,1.95-2.82,2.55l4.49,7.75h-5.18l-3.98-6.93ZM316.41,168.2h3.62c.66,0,1.23-.26,1.7-.79.47-.52.71-1.16.71-1.93s-.23-1.41-.71-1.93-1.04-.78-1.7-.78h-3.62v5.42Z"
      />
    </g>
    <polygon
      :class="{ st8: !props.fill }"
      points="351.22 174.71 351.22 179.35 337.96 179.35 337.96 158.26 351.07 158.26 351.07 162.9 342.79 162.9 342.79 166.39 350.32 166.39 350.32 170.97 342.79 170.97 342.79 174.71 351.22 174.71"
    />
    <g :class="{ st1: !props.fill }">
      <path
        :class="{ st8: !props.fill }"
        d="M363.91,176.61c-2.13-2.11-3.19-4.71-3.19-7.81s1.06-5.69,3.19-7.8c2.13-2.11,4.72-3.16,7.78-3.16s5.64,1.05,7.77,3.16c2.13,2.11,3.19,4.71,3.19,7.8s-1.07,5.7-3.19,7.81c-2.13,2.11-4.72,3.16-7.77,3.16s-5.65-1.05-7.78-3.16M376.07,173.32c1.18-1.16,1.76-2.67,1.76-4.52s-.59-3.35-1.76-4.52c-1.18-1.17-2.64-1.75-4.38-1.75s-3.21.58-4.39,1.75c-1.18,1.17-1.76,2.67-1.76,4.52s.59,3.36,1.76,4.52c1.17,1.17,2.64,1.75,4.39,1.75s3.21-.58,4.38-1.75"
      />
    </g>
    <polygon
      :class="{ st8: !props.fill }"
      points="406.16 162.9 400.74 162.9 400.74 179.35 395.92 179.35 395.92 162.9 390.49 162.9 390.49 158.26 406.16 158.26 406.16 162.9"
    />
    <rect :class="{ st8: !props.fill }" x="416.11" y="158.26" width="4.82" height="21.09" />
    <g :class="{ st4: !props.fill }">
      <path
        :class="{ st8: !props.fill }"
        d="M448.13,161.28c1.96,2.02,2.94,4.53,2.94,7.52s-.98,5.5-2.94,7.52c-1.96,2.02-4.4,3.03-7.31,3.03h-8.44v-21.1h8.44c2.91,0,5.35,1.01,7.31,3.03M444.87,173.1c1.04-1.08,1.55-2.51,1.55-4.3s-.52-3.22-1.55-4.29c-1.03-1.08-2.39-1.61-4.05-1.61h-3.62v11.81h3.62c1.67,0,3.02-.54,4.05-1.61"
      />
    </g>
    <polygon
      :class="{ st8: !props.fill }"
      points="474.88 174.71 474.88 179.35 461.62 179.35 461.62 158.26 474.73 158.26 474.73 162.9 466.44 162.9 466.44 166.39 473.97 166.39 473.97 170.97 466.44 170.97 466.44 174.71 474.88 174.71"
    />
    <g :class="{ st0: !props.fill }">
      <path
        :class="{ st8: !props.fill }"
        d="M471.1,212.41l.06-.12c2.73-4.03,4.27-8.19,4.27-13.05s-1.54-9.02-4.27-13.05l-.06-.12-3.05,1.78c2.4,3.77,3.83,6.79,3.83,11.39s-1.42,7.62-3.83,11.39l3.05,1.78ZM446.56,207.78h14.8v-4.27h-10.18v-4.31h9.11v-4.27h-9.11v-3.89h9.64v-4.27h-14.27v21ZM428.94,207.78h4.63v-16.91h5.99v-4.09h-16.61v4.09h5.99v16.91ZM412.41,199.42h-5.13l2.55-6.52,2.58,6.52ZM398.98,207.78h5.1l1.75-4.45h8.16l1.81,4.45h5.22l-9.14-21h-3.83l-9.08,21ZM386.42,207.78h4.63v-16.91h5.99v-4.09h-16.61v4.09h5.99v16.91ZM359.37,207.78h14.8v-4.27h-10.18v-4.31h9.11v-4.27h-9.11v-3.89h9.64v-4.27h-14.27v21ZM351.68,189.33c-1.78-2.28-4.75-3.08-7.09-3.08-6.56,0-11.33,4.3-11.33,11.03s4.77,11.03,11.33,11.03c2.88,0,5.85-1.16,7.59-3.64l-3.86-2.88c-.95,1.42-2.46,2.26-4.33,2.26-3.35,0-5.93-2.85-5.93-6.77s2.58-6.77,6.08-6.77c1.72,0,3.05.62,3.97,1.72l3.56-2.91ZM319.2,199.42h-5.13l2.55-6.52,2.58,6.52ZM305.76,207.78h5.1l1.75-4.45h8.16l1.81,4.45h5.22l-9.14-21h-3.83l-9.07,21ZM286.71,188.44c-1.78-1.57-4.06-2.19-6.43-2.19-4.13,0-8.01,2.34-8.01,6.82,0,7,9.85,4.93,9.85,8.78,0,1.48-1.69,2.2-3.21,2.2s-3.09-.74-4.03-1.99l-3.29,3.62c1.99,1.84,4.36,2.64,7.06,2.64,4.34,0,8.1-2.22,8.1-6.91,0-7.36-9.67-4.9-9.67-8.72,0-1.57,1.81-2.17,3.12-2.17,1.13,0,2.61.45,3.35,1.4l3.17-3.47ZM257.96,199.42h-5.13l2.55-6.52,2.58,6.52ZM244.53,207.78h5.1l1.75-4.45h8.16l1.81,4.45h5.22l-9.14-21h-3.83l-9.08,21ZM236.39,186.07l-.06.12c-2.73,4.03-4.27,8.19-4.27,13.05s1.54,9.02,4.27,13.05l.06.12,3.06-1.78c-2.41-3.77-3.83-6.79-3.83-11.39s1.42-7.62,3.83-11.39l-3.06-1.78Z"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
interface SVGProps {
  height: string
  width: string
  fill?: string
}

const props = defineProps<SVGProps>()
</script>

<style scoped>
.st0 {
  clip-path: url(#clippath-6);
}

.st1 {
  clip-path: url(#clippath-4);
}

.st2 {
  fill: none;
}

.st3 {
  clip-path: url(#clippath-1);
}

.st4 {
  clip-path: url(#clippath-5);
}

.st5 {
  clip-path: url(#clippath-3);
}

.st6 {
  clip-path: url(#clippath-2);
}

.st7 {
  clip-path: url(#clippath);
}

.st8 {
  fill: #ffffff;
}
</style>
